import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyEmailMarketing} from './help-body-email-marketing';
import {HelpGraphicEmailMarketing} from './help-graphic-email-marketing';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export class HelpEmailMarketing extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}
                    noPadding={true}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='singlePage'
                        bodyComponent={<HelpBodyEmailMarketing />}
                        artBackgroundColor={colors.plumDk}
                        artImage={<HelpGraphicEmailMarketing />}
                        buttonText='Done'
                        onClose={this.props.onClose}
                    />
                </Modal>
            </div>
        );
    }
}
